import { render, staticRenderFns } from "./PrivacyPolicyView.vue?vue&type=template&id=4df02a9c&scoped=true"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyView.vue?vue&type=style&index=0&id=4df02a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df02a9c",
  null
  
)

export default component.exports